module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/high_protein--xxl@1x-dee74d4f2efa6920cef8d5c85e072758.png";